/**
 * Cart subscription guard: block checkout when cart contains services/integrations
 * the fleet already subscribes to. Re-runs after getdetails (apiCallsComplete) so
 * shared-cart and slow API loads cannot slip through on stale or empty fetchData.
 */
(function () {
  function normalizeSku(sku) {
    return String(sku || '')
      .replace(/-/g, '')
      .toLowerCase();
  }

  function getSubscribedSkusFromStorage() {
    try {
      var raw = localStorage.getItem('fetchData');
      if (!raw) return null;
      var fetchedData = JSON.parse(raw);
      if (
        fetchedData.subscriber_list &&
        Array.isArray(fetchedData.subscriber_list.subscribed_products)
      ) {
        return fetchedData.subscriber_list.subscribed_products;
      }
      if (Array.isArray(fetchedData.records)) {
        return fetchedData.records;
      }
      return [];
    } catch (e) {
      return null;
    }
  }

  function isSkuSubscribed(cartSku, subscribedSkus) {
    if (!cartSku || !subscribedSkus || !subscribedSkus.length) return false;
    var cartNorm = normalizeSku(cartSku);
    return subscribedSkus.some(function (record) {
      var recordStr = String(record);
      return recordStr === String(cartSku) || normalizeSku(record) === cartNorm;
    });
  }

  function isSubscriptionValidatableProduct(product) {
    if (!product) return false;
    return (
      (product.type === 'Services' && product.sku !== window.PREM_REPORT_PAID) ||
      product.type === 'Integrations' ||
      product.type === 'freebie'
    );
  }

  function cartNeedsSubscriptionData(products) {
    return Array.isArray(products) && products.some(isSubscriptionValidatableProduct);
  }

  function subscriptionDataStillLoading() {
    if (localStorage.getItem('fetchDone') === 'true') return false;
    return (
      window._skeletonAwaitingApi === true ||
      sessionStorage.getItem('apiCallsPending') === 'true'
    );
  }

  function applyCartSubscribedServicesValidation(products) {
    var checkoutButton = document.getElementById('checkout');
    var warningElement = document.getElementById('checkout-without-unsubscribed-cable');
    var result = { blocked: false, pending: false };

    if (!checkoutButton || !Array.isArray(products)) {
      window.ds2CartHasSubscribedServicesConflict = false;
      return result;
    }

    var needsSubscriptionData = cartNeedsSubscriptionData(products);
    var subscribedSkus = getSubscribedSkusFromStorage();
    var wasPending =
      checkoutButton.getAttribute('data-ds2-subscription-check-pending') === 'true';
    var stillLoading =
      needsSubscriptionData &&
      (subscribedSkus === null || subscriptionDataStillLoading());

    if (stillLoading) {
      checkoutButton.disabled = true;
      checkoutButton.setAttribute('data-ds2-subscription-check-pending', 'true');
      window.ds2CartHasSubscribedServicesConflict = false;
      result.pending = true;
      return result;
    }

    checkoutButton.removeAttribute('data-ds2-subscription-check-pending');
    subscribedSkus = subscribedSkus || [];

    var warningFlag = false;

    products.forEach(function (product, index) {
      if (!isSubscriptionValidatableProduct(product)) return;

      var sku = product.sku;
      var anchorTag = document.getElementById(sku);

      if (sku === window.PREM_REPORT) {
        var deviceCount = parseInt(localStorage.getItem('total_device_count'), 10);
        if (!isSkuSubscribed(sku, subscribedSkus) && deviceCount < 200) {
          warningFlag = true;
          if (anchorTag) anchorTag.style.color = 'red';
          return;
        }
      }

      if (isSkuSubscribed(sku, subscribedSkus)) {
        warningFlag = true;
        if (anchorTag) anchorTag.style.color = 'red';
        return;
      }

      if (anchorTag) anchorTag.style.color = 'black';
    });

    window.ds2CartHasSubscribedServicesConflict = warningFlag;
    result.blocked = warningFlag;

    if (warningFlag) {
      checkoutButton.disabled = true;
      if (warningElement) warningElement.style.display = 'block';
    } else {
      if (warningElement) warningElement.style.display = 'none';
      if (wasPending) {
        checkoutButton.disabled = false;
      }
    }

    return result;
  }

  function runValidation() {
    return applyCartSubscribedServicesValidation(
      window.cartProductsForSubscriptionValidation || []
    );
  }

  window.ds2ApplyCartSubscribedServicesValidation = runValidation;

  window.ds2ValidateCartSubscribedBeforeCheckout = function () {
    var result = applyCartSubscribedServicesValidation(
      window.cartProductsForSubscriptionValidation || []
    );
    return !result.blocked && !result.pending;
  };

  document.addEventListener('DOMContentLoaded', runValidation);
  document.addEventListener('apiCallsComplete', runValidation);
})();
